<template>
  <div class="contacts" data-page="contacts">
    <address class="contacts__mails">
      <p data-enter="fade" v-html="contacts[$store.state.lang].intro">
      </p>
      <ul>
        <li
          v-for="(contact, i) in contacts[$store.state.lang].mails"
          :key="i"
        >
          <p data-enter="fade">{{contact.title}}</p>
          <a :href="`mailto:${contact.content}`" data-enter="title">{{contact.content}}</a>
        </li>
      </ul>
    </address>
    <address class="contacts__directions">
      <a
        class="directions__url"
        href="https://goo.gl/maps/2MmTzHzxmRuGsPnd7"
        data-enter="title"
        target="_blank"
        rel="noopener"
      >Get directions</a>
      <p class="directions__title">
        <strong data-enter="fade">{{ contacts[$store.state.lang].title }}</strong>
      </p>
      <p class="directions__content" data-enter="fade">
        Via Silvio Pellico, 20<br>
        25122 - Brescia - Italy<br>
        <a href="tel:3715363825" target="_blank" rel="noopener">Tel: 371 53 63 825</a>
      </p>
    </address>
  </div>
</template>

<script>
import TimelineLite from 'gsap/TimelineLite';
import { Power4 } from 'gsap/EasePack';
import { qsa } from '@/scripts/utils';

import contacts from '@/assets/data/contacts.json';


export default {
  name: 'contacts',

  data() {
    return {
      contacts,
    };
  },

  mounted() {
    this.enterAnimation();
  },

  methods: {
    enterAnimation() {
      const elsToTween = qsa('[data-enter="title"]', this.$el);
      elsToTween.forEach(el => el.removeAttribute('data-enter'));

      const tl = new TimelineLite({ delay: 1 });

      tl.addLabel('start')
        .to(this.$el, 0.3, { autoAlpha: 1, clearProps: 'all' }, 'start')
        .fromTo('[data-enter="fade"]', 4, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          ease: Power4.easeOut,
        }, 'start')
        .staggerFromTo(elsToTween, 1, {
          x: 100,
          skewX: -30,
          autoAlpha: 0,
          transformOrigin: 'center',
        }, {
          x: 0,
          skewX: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 0.15, 'start');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/colors';
@import '../style/variables';
@import '../style/functions';


.contacts {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0 25px 20px 20px;

  box-sizing: border-box;

  display: flex;
  align-items: flex-end;
  flex-flow: column nowrap;
  justify-content: flex-end;

  overflow: scroll;

  @include mq(mobileL) {
    padding: 0 75px 60px 65px;

    flex-flow: row wrap;
    justify-content: space-between;

    overflow: hidden;
  }

  address {
    font-style: normal;
  }

  &__mails {
    display: inline-block;
    position: relative;
    width: 100%;

    @include mq(mobileL) {
      width: auto;
      flex: 0 0 auto;
    }

    ul {
      margin-top: 40px;
      overflow: hidden;
      width: 100%;

      @include mq(mobileL) {
        margin-top: 80px;
      }

      @include mq(ds) {
        overflow: visible;
      }

      p {
        width: 100%;
        margin-bottom: 10px;
        overflow: hidden;

        @include mq(mobileL) {
          margin-bottom: 20px;
        }

        @include mq(ds) {
          overflow: visible;
        }
      }

      a {
        display: inline-block;
        font-size: font-size(l);
        font-weight: bold;

        transition: color 0.3s ease-in-out;

        @include mq(mobileL) {
          font-weight: normal;
          -webkit-text-stroke: 1px $color-text;
          color: transparent;
          font-size: font-size(xl);
        }

        @include mq($and: $is-not-touch-device) {
          &:hover {
            color: $color-text;
          }
        }
      }

      li {
        margin-bottom: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }

        @include mq(mobileL) {
          margin-bottom: 50px;
        }
      }
    }
  }

  &__directions {
    margin-top: 40px;
    width: 100%;

    @include mq(mobileL) {
      width: auto;
      flex: 0 0 auto;
    }

    .directions__url {
      display: inline-block;
      margin-bottom: 10px;

      font-size: font-size(xl-mobile);
      -webkit-text-stroke: 1px $color-text;
      color: transparent;

      transition: color 0.3s ease-in-out;

      @include mq(mobileL) {
        margin-bottom: 30px;
        font-size: font-size(xl);
      }

      &:hover {
        color: $color-text;
      }
    }

    .directions__title {
      margin-bottom: 20px;
      text-transform: uppercase;
    }

    .directions__content {
      color: rgba($color-text, 0.75);
    }
  }
}
</style>
